<template>
  <basic-dialog :show="show" @close="$emit('close')" maxWidth="700">
    <template v-slot:title>Edit Doc</template>
    <v-row>
      <v-col cols="8">
        <v-text-field
          v-model="name"
          label="Name"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-select
          label="format"
          v-model="format"
          :items="formats"
          :outlined="outlinedInputs"
        ></v-select>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <div v-if="debug">
      <code>{{ value }}</code>
    </div>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
export default {
  name: "document-type-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      formats: ["A4", "Letter"],
      format: this.value ? this.value.format : "A4",
      name: this.value ? this.value.name : "",
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return this.name != "";
    },
  },

  watch: {
    value(newVal) {
      this.name = newVal.name;
      this.format = newVal.format;
    },
  },

  methods: {
    onSave() {
      this.$emit("update", {
        name: this.name,
        format: this.format,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/user-access-controls/DocumentTypeDialog.vue